import { Product } from '@/lib/index';
import { IMAGES } from '@/assets/images';

export const STENCIL_PRODUCTS: Product[] = [
  {
    id: 'stencil-1',
    name: 'Premium Stencil Transfer Liquid',
    category: 'stencils',
    price: 24.99,
    image: IMAGES.STENCIL_1,
    description: 'Professional-grade stencil transfer liquid for crisp, long-lasting stencil application. Perfect lines every time.',
    rating: 4.9,
    reviewCount: 127,
  },
  {
    id: 'stencil-2',
    name: 'Ultra-Clear Stencil Solution',
    category: 'stencils',
    price: 19.99,
    image: IMAGES.STENCIL_2,
    description: 'Crystal-clear formula ensures precise stencil placement with no smudging or bleeding.',
    rating: 4.8,
    reviewCount: 94,
  },
  {
    id: 'stencil-3',
    name: 'Quick-Dry Stencil Primer',
    category: 'stencils',
    price: 22.99,
    image: IMAGES.STENCIL_3,
    description: 'Fast-drying primer that locks stencils in place for extended tattoo sessions.',
    rating: 4.9,
    reviewCount: 156,
  },
  {
    id: 'stencil-4',
    name: 'Professional Stencil Gel',
    category: 'stencils',
    price: 27.99,
    image: IMAGES.STENCIL_4,
    description: 'Thick gel formula provides superior adhesion and clarity for complex designs.',
    rating: 4.7,
    reviewCount: 83,
  },
  {
    id: 'stencil-5',
    name: 'Sensitive Skin Stencil Liquid',
    category: 'stencils',
    price: 26.99,
    image: IMAGES.STENCIL_5,
    description: 'Hypoallergenic formula perfect for clients with sensitive skin. No irritation guaranteed.',
    rating: 4.9,
    reviewCount: 112,
  },
  {
    id: 'stencil-6',
    name: 'Long-Lasting Stencil Solution',
    category: 'stencils',
    price: 23.99,
    image: IMAGES.STENCIL_6,
    description: 'Extended wear formula keeps stencils visible throughout multi-hour sessions.',
    rating: 4.8,
    reviewCount: 145,
  },
  {
    id: 'stencil-7',
    name: 'Eco-Friendly Stencil Transfer',
    category: 'stencils',
    price: 25.99,
    image: IMAGES.STENCIL_7,
    description: 'Environmentally conscious formula with professional-grade performance.',
    rating: 4.6,
    reviewCount: 67,
  },
  {
    id: 'stencil-8',
    name: 'Pro Artist Stencil Liquid',
    category: 'stencils',
    price: 29.99,
    image: IMAGES.STENCIL_8,
    description: 'Premium formula trusted by professional tattoo artists worldwide.',
    rating: 4.9,
    reviewCount: 203,
  },
];

export const CARTRIDGE_PRODUCTS: Product[] = [
  {
    id: 'cartridge-1',
    name: 'Round Liner Cartridges - 0.30mm',
    category: 'cartridges',
    price: 34.99,
    image: IMAGES.CARTRIDGE_1,
    description: 'Precision round liner cartridges for crisp, clean lines. Box of 20 cartridges.',
    rating: 4.9,
    reviewCount: 189,
  },
  {
    id: 'cartridge-2',
    name: 'Magnum Shader Cartridges - 0.35mm',
    category: 'cartridges',
    price: 39.99,
    image: IMAGES.CARTRIDGE_2,
    description: 'Professional magnum shader cartridges for smooth color packing and shading.',
    rating: 4.8,
    reviewCount: 167,
  },
  {
    id: 'cartridge-3',
    name: 'Round Shader Cartridges - 0.30mm',
    category: 'cartridges',
    price: 36.99,
    image: IMAGES.CARTRIDGE_3,
    description: 'Versatile round shader cartridges perfect for blending and soft shading.',
    rating: 4.9,
    reviewCount: 201,
  },
  {
    id: 'cartridge-4',
    name: 'Curved Magnum Cartridges - 0.35mm',
    category: 'cartridges',
    price: 42.99,
    image: IMAGES.CARTRIDGE_4,
    description: 'Curved magnum design for ergonomic shading and color saturation.',
    rating: 4.7,
    reviewCount: 134,
  },
  {
    id: 'cartridge-5',
    name: 'Bugpin Liner Cartridges - 0.25mm',
    category: 'cartridges',
    price: 37.99,
    image: IMAGES.CARTRIDGE_5,
    description: 'Ultra-fine bugpin liners for intricate detail work and delicate lines.',
    rating: 4.9,
    reviewCount: 178,
  },
  {
    id: 'cartridge-6',
    name: 'Textured Magnum Cartridges - 0.35mm',
    category: 'cartridges',
    price: 41.99,
    image: IMAGES.CARTRIDGE_6,
    description: 'Specialized texture magnums for creating unique shading effects.',
    rating: 4.6,
    reviewCount: 92,
  },
  {
    id: 'cartridge-7',
    name: 'Flat Shader Cartridges - 0.30mm',
    category: 'cartridges',
    price: 38.99,
    image: IMAGES.CARTRIDGE_7,
    description: 'Flat configuration for bold lines and solid color fills.',
    rating: 4.8,
    reviewCount: 156,
  },
  {
    id: 'cartridge-8',
    name: 'Round Liner Cartridges - 0.35mm',
    category: 'cartridges',
    price: 35.99,
    image: IMAGES.CARTRIDGE_8,
    description: 'Slightly thicker round liners for bold, confident line work.',
    rating: 4.9,
    reviewCount: 211,
  },
  {
    id: 'cartridge-9',
    name: 'Soft Edge Magnum Cartridges - 0.30mm',
    category: 'cartridges',
    price: 40.99,
    image: IMAGES.CARTRIDGE_9,
    description: 'Soft edge magnums for seamless blending and gradient work.',
    rating: 4.8,
    reviewCount: 143,
  },
  {
    id: 'cartridge-10',
    name: 'Power Liner Cartridges - 0.40mm',
    category: 'cartridges',
    price: 36.99,
    image: IMAGES.CARTRIDGE_10,
    description: 'Heavy-duty power liners for thick, bold outlines and tribal work.',
    rating: 4.7,
    reviewCount: 128,
  },
];

export const INK_PRODUCTS: Product[] = [
  {
    id: 'ink-1',
    name: 'Midnight Black Tattoo Ink - 8oz',
    category: 'ink',
    price: 44.99,
    image: IMAGES.TATTOO_INK_1,
    description: 'Deep, rich black ink with superior pigment density. Perfect for bold lines and solid fills.',
    rating: 4.9,
    reviewCount: 234,
  },
  {
    id: 'ink-2',
    name: 'Crimson Red Tattoo Ink - 4oz',
    category: 'ink',
    price: 32.99,
    image: IMAGES.TATTOO_INK_2,
    description: 'Vibrant red ink with excellent color retention and smooth flow.',
    rating: 4.8,
    reviewCount: 187,
  },
  {
    id: 'ink-3',
    name: 'Ocean Blue Tattoo Ink - 4oz',
    category: 'ink',
    price: 34.99,
    image: IMAGES.TATTOO_INK_3,
    description: 'Brilliant blue ink that heals true to color with minimal fading.',
    rating: 4.9,
    reviewCount: 198,
  },
  {
    id: 'ink-4',
    name: 'Forest Green Tattoo Ink - 4oz',
    category: 'ink',
    price: 33.99,
    image: IMAGES.TATTOO_INK_4,
    description: 'Rich green ink perfect for nature-inspired designs and color blending.',
    rating: 4.7,
    reviewCount: 156,
  },
  {
    id: 'ink-5',
    name: 'Sunset Orange Tattoo Ink - 4oz',
    category: 'ink',
    price: 31.99,
    image: IMAGES.TATTOO_INK_5,
    description: 'Warm orange ink with high visibility and excellent mixing properties.',
    rating: 4.8,
    reviewCount: 143,
  },
  {
    id: 'ink-6',
    name: 'Royal Purple Tattoo Ink - 4oz',
    category: 'ink',
    price: 35.99,
    image: IMAGES.TATTOO_INK_6,
    description: 'Deep purple ink with rich pigmentation and smooth application.',
    rating: 4.9,
    reviewCount: 167,
  },
  {
    id: 'ink-7',
    name: 'Bright Yellow Tattoo Ink - 4oz',
    category: 'ink',
    price: 30.99,
    image: IMAGES.TATTOO_INK_7,
    description: 'Luminous yellow ink that stands out in color compositions.',
    rating: 4.6,
    reviewCount: 124,
  },
  {
    id: 'ink-8',
    name: 'Warm Brown Tattoo Ink - 4oz',
    category: 'ink',
    price: 32.99,
    image: IMAGES.TATTOO_INK_8,
    description: 'Natural brown ink ideal for portraits and realistic work.',
    rating: 4.8,
    reviewCount: 178,
  },
  {
    id: 'ink-9',
    name: 'Cool Gray Tattoo Ink - 4oz',
    category: 'ink',
    price: 33.99,
    image: IMAGES.TATTOO_INK_9,
    description: 'Neutral gray ink perfect for shading and black-and-gray work.',
    rating: 4.9,
    reviewCount: 201,
  },
  {
    id: 'ink-10',
    name: 'Pure White Tattoo Ink - 4oz',
    category: 'ink',
    price: 36.99,
    image: IMAGES.TATTOO_INK_10,
    description: 'Opaque white ink for highlights and cover-up work.',
    rating: 4.7,
    reviewCount: 145,
  },
];

export const AFTERCARE_PRODUCTS: Product[] = [
  {
    id: 'aftercare-1',
    name: 'Healing Balm - 2oz',
    category: 'aftercare',
    price: 18.99,
    image: IMAGES.STENCIL_1,
    description: 'Nourishing balm that promotes healing and protects new tattoos. Natural ingredients.',
    rating: 4.9,
    reviewCount: 312,
  },
  {
    id: 'aftercare-2',
    name: 'Tattoo Moisturizer - 4oz',
    category: 'aftercare',
    price: 22.99,
    image: IMAGES.STENCIL_2,
    description: 'Lightweight moisturizer that keeps tattoos vibrant and skin hydrated.',
    rating: 4.8,
    reviewCount: 267,
  },
  {
    id: 'aftercare-3',
    name: 'Gentle Cleansing Foam - 6oz',
    category: 'aftercare',
    price: 16.99,
    image: IMAGES.STENCIL_3,
    description: 'pH-balanced foam cleanser designed specifically for fresh tattoos.',
    rating: 4.9,
    reviewCount: 289,
  },
  {
    id: 'aftercare-4',
    name: 'Soothing Gel - 3oz',
    category: 'aftercare',
    price: 19.99,
    image: IMAGES.STENCIL_4,
    description: 'Cooling gel that reduces redness and irritation during the healing process.',
    rating: 4.7,
    reviewCount: 198,
  },
  {
    id: 'aftercare-5',
    name: 'Protective Barrier Cream - 2oz',
    category: 'aftercare',
    price: 21.99,
    image: IMAGES.STENCIL_5,
    description: 'Creates a breathable barrier that protects tattoos from environmental damage.',
    rating: 4.8,
    reviewCount: 234,
  },
  {
    id: 'aftercare-6',
    name: 'Vitamin E Serum - 1oz',
    category: 'aftercare',
    price: 24.99,
    image: IMAGES.STENCIL_6,
    description: 'Concentrated vitamin E serum for enhanced healing and color preservation.',
    rating: 4.9,
    reviewCount: 276,
  },
  {
    id: 'aftercare-7',
    name: 'Antibacterial Spray - 4oz',
    category: 'aftercare',
    price: 15.99,
    image: IMAGES.STENCIL_7,
    description: 'Gentle antibacterial spray that prevents infection without harsh chemicals.',
    rating: 4.8,
    reviewCount: 245,
  },
  {
    id: 'aftercare-8',
    name: 'Complete Care Kit',
    category: 'aftercare',
    price: 49.99,
    image: IMAGES.STENCIL_8,
    description: 'All-in-one aftercare kit with cleanser, balm, and moisturizer. Everything you need.',
    rating: 4.9,
    reviewCount: 401,
  },
];

export const ALL_PRODUCTS: Product[] = [
  ...STENCIL_PRODUCTS,
  ...CARTRIDGE_PRODUCTS,
  ...INK_PRODUCTS,
  ...AFTERCARE_PRODUCTS,
];